module.exports = __webpack_public_path__ + "static/media/6-1.eed304d4.mp3";